import { useTheme } from '../../../../../../hooks/useTheme';
import { CirclePlus } from '../../../../../icons';
import { NewOptionFooterProps } from './NewOptionFooter.types';
import { useStyles } from './NewOptionFooter.styles';
import { Typography } from '../../../../../Typography';

export const NewOptionFooter = ({ label, onClick }: NewOptionFooterProps) => {
  const theme = useTheme();
  const styles = useStyles();

  return (
    <button type="button" css={styles.root} onClick={onClick}>
      <Typography className="pointer-events-none !text-h5 !text-secondary-900">{label}</Typography>
      <CirclePlus
        role="img"
        aria-label="Add Button"
        size="1.2rem"
        color={theme.palette.secondary.dark}
        css={styles.icon}
      >
        <title>Add Button</title>
      </CirclePlus>
    </button>
  );
};
